import React, { FC } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface SearchProps {
  value?: string;
  disabled?: boolean;
  placeholderText?: string;
  onChange?: (e) => void;
  onClear?: (e) => void;
}

const Search: FC<SearchProps> = ({
  value,
  disabled = false,
  placeholderText = "Search",
  onChange = () => {},
  onClear = () => {},
}) => {
  return (
    <div
      className="relative border-2 border-dark-white-64 px-20 h-48 w-full flex flex-row items-center"
      style={{ borderRadius: "40px" }}
    >
      <SearchIcon
        style={{ fontSize: "24px" }}
        className="fill-current text-dark-white-64"
      />
      <input
        type="text"
        placeholder={placeholderText}
        value={value}
        disabled={disabled}
        className="w-full bg-transparent border-none focus:ring-transparent focus:ring-none focus:border-none focus:outline-none"
        onChange={onChange}
      />
      {value !== "" && (
        <ClearIcon
          style={{ fontSize: "24px" }}
          className="fill-current text-dark-white-64 cursor-pointer"
          onClick={onClear}
        />
      )}
    </div>
  );
};

export default Search;
